declare namespace $ {

	export class $mol_icon_filmstrip extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=filmstrip.view.tree.d.ts.map